module.exports = __webpack_public_path__ + "img/Hand_31_05_16.c69a4e09.png";